import { handleErrors } from '.';

import type { CommentFormData } from '../types/forms/commentform';

export const APIcreateComment = async (memoryId: string, params: CommentFormData) => (
  window.axios.post(`/api/memories/${memoryId}/comments`, params)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIupdateComment = async (commentId: number, params: CommentFormData) => (
  window.axios.patch(`/api/comments/${commentId}`, params)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIdeleteComment = async (commentId: number) => (
  window.axios.delete(`/api/comments/${commentId}`)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);
